window.initTips = function (context) {
  $(context).find('[data-tooltip]').powerTip({
    smartPlacement: true,
    mouseOnToPopup: true,
  });
};

$(() => { window.initTips(document); });
